'use client';

import { c as _c } from "react/compiler-runtime";
import { Radio } from '@common/components';
import { cn } from '@core/utils';
import { useRef } from 'react';
import type { GiftProductDetail } from '@/api/getGiftProductDetail';
import { calculateRequiredDonationAmount, resolveMaxGiftOrderQuantity } from '@/app/donation/_utils/giftOrder';
import { GIFT_SALE_STATUS } from '@/app/donation/constants';
import { QuantityStepper } from '@/components/molecule/QuantityStepper';
import { formatOptionLabel } from '../../../../_utils/formatOptionLabel';
import { useGiftOption } from '../../_context/GiftOptionContext';
import { calculateGiftDonationAmount } from '../../_utils/calculateGiftDonationAmount';
import { GiftDonateButton } from '../GiftDonateButton';
interface PrefillFormProps {
  productData?: GiftProductDetail;
  productNumber: string;
  className?: string;
}
export const PrefillForm = t0 => {
  const $ = _c(45);
  const {
    productData,
    productNumber,
    className
  } = t0;
  const {
    selectedOptions,
    handleOptionSelect,
    getSelectedOptions,
    quantity,
    handleQuantityChange,
    resetSelection
  } = useGiftOption();
  const optionGroups = productData?.optionGroupInfoList ?? [];
  const hasOptions = optionGroups.length > 0;
  const currentPrice = productData?.currentPrice ?? 0;
  const isNotOnSale = productData !== undefined && productData.productSaleStatus !== GIFT_SALE_STATUS.ON_SALE;
  const requiredOptionGroups = optionGroups.filter(_temp);
  const isAllRequiredOptionsSelected = hasOptions && requiredOptionGroups.every(g_0 => selectedOptions.has(g_0.optionGroupId ?? 0));
  let t1;
  bb0: {
    if (!isAllRequiredOptionsSelected) {
      t1 = null;
      break bb0;
    }
    const optionNames = [];
    optionGroups.forEach(group => {
      const selected = selectedOptions.get(group.optionGroupId ?? 0);
      if (selected) {
        const optionItem = group.optionItemInfoList?.find(item => item.optionItemId === selected.optionItemId);
        if (optionItem?.itemName) {
          optionNames.push(optionItem.itemName);
        }
      }
    });
    t1 = optionNames.join(" ");
  }
  const selectedOptionText = t1;
  const quantityLabel = hasOptions ? selectedOptionText : "\uC218\uB7C9";
  const extraProductPrices = Array.from(selectedOptions.values()).map(_temp2);
  const baseDonationAmount = calculateRequiredDonationAmount(currentPrice);
  const totalPrice = calculateGiftDonationAmount({
    currentPrice,
    extraProductPrices,
    quantity,
    hasOptions
  });
  const unitDonationAmount = calculateGiftDonationAmount({
    currentPrice,
    extraProductPrices,
    quantity: 1,
    hasOptions
  });
  const isSingleOptionGroup = optionGroups.length === 1;
  const requiredOptionGroupIds = optionGroups.filter(_temp3).map(_temp4);
  const optionSectionRef = useRef(null);
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      optionSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const scrollToOptionSection = t2;
  if (!productData) {
    return null;
  }
  const t3 = _temp5;
  let t4;
  if ($[1] !== className) {
    t4 = cn("flex flex-col gap-36", className);
    $[1] = className;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== baseDonationAmount || $[4] !== currentPrice || $[5] !== handleOptionSelect || $[6] !== isSingleOptionGroup || $[7] !== optionGroups || $[8] !== selectedOptions) {
    let t6;
    if ($[10] !== baseDonationAmount || $[11] !== currentPrice || $[12] !== handleOptionSelect || $[13] !== isSingleOptionGroup || $[14] !== selectedOptions) {
      t6 = optionGroup => {
        const groupId = optionGroup.optionGroupId ?? 0;
        const selectedInGroup = selectedOptions.get(groupId);
        return <div key={groupId} className="flex flex-col">{optionGroup.optionGroupName && <p className="flex items-center gap-4 pb-8 pt-16 font-500 text-Gray-600 typo-body4">{isSingleOptionGroup ? "\uB2F5\uB840\uD488 \uC635\uC158 \uC120\uD0DD" : optionGroup.optionGroupName}{optionGroup.requiredYN && <span className="font-600 text-R-500">*</span>}</p>}<Radio.Group value={selectedInGroup?.optionItemId} onChange={selectedItemId => {
            const selectedItem = optionGroup.optionItemInfoList?.find(item_0 => item_0.optionItemId === selectedItemId);
            if (selectedItem && !selectedItem.displaySoldOutYN) {
              handleOptionSelect(groupId, selectedItemId as number, selectedItem.extraProductPrice ?? 0);
            }
          }} theme="black" className="flex flex-col">{optionGroup.optionItemInfoList?.map(optionItem_0 => {
              const itemId = optionItem_0.optionItemId ?? 0;
              const isSoldOut = optionItem_0.displaySoldOutYN ?? false;
              const displayLabel = formatOptionLabel(optionItem_0.itemName ?? "", {
                isSoldOut,
                extraDonationAmount: calculateRequiredDonationAmount(currentPrice + (optionItem_0.extraProductPrice ?? 0)) - baseDonationAmount
              });
              return <div key={itemId} className="flex items-center gap-16 border-b border-Gray-200 py-16"><Radio.Item value={itemId} disabled={isSoldOut} className={cn("flex-1", isSoldOut && "cursor-not-allowed opacity-50")}><span className="flex-1 text-left font-400 text-Gray-700 typo-body4">{displayLabel}</span></Radio.Item></div>;
            })}</Radio.Group></div>;
      };
      $[10] = baseDonationAmount;
      $[11] = currentPrice;
      $[12] = handleOptionSelect;
      $[13] = isSingleOptionGroup;
      $[14] = selectedOptions;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    t5 = optionGroups.map(t6);
    $[3] = baseDonationAmount;
    $[4] = currentPrice;
    $[5] = handleOptionSelect;
    $[6] = isSingleOptionGroup;
    $[7] = optionGroups;
    $[8] = selectedOptions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const t6 = quantityLabel && <div className="rounded-small bg-Gray-25 p-12"><div className="flex w-full items-center justify-between"><span className="font-400 text-Gray-800 typo-caption1">{quantityLabel}</span><QuantityStepper count={quantity} disabled={isNotOnSale} max={resolveMaxGiftOrderQuantity(unitDonationAmount)} onCountChange={handleQuantityChange} onDelete={hasOptions ? resetSelection : undefined} className="mobile-tablet:h-36 mobile-tablet:w-90" /></div></div>;
  let t7;
  if ($[16] !== t5 || $[17] !== t6) {
    t7 = <div ref={optionSectionRef} data-gift-option-section={true} className="flex flex-col gap-28">{t5}{t6}</div>;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const t8 = "flex flex-col gap-24 mobile:hidden tablet:hidden";
  const t9 = "flex items-center justify-between";
  let t10;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="font-600 text-Gray-900 typo-h6">기부금액</span>;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  const t11 = "flex items-center gap-2 font-800 text-Gray-900 typo-h4";
  const t12 = totalPrice.toLocaleString("ko-KR");
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <span>원</span>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t12) {
    t14 = <span className={t11}>{t12}{t13}</span>;
    $[21] = t12;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t10 || $[24] !== t14) {
    t15 = <div className={t9}>{t10}{t14}</div>;
    $[23] = t10;
    $[24] = t14;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== getSelectedOptions || $[27] !== optionGroups) {
    t16 = getSelectedOptions(optionGroups);
    $[26] = getSelectedOptions;
    $[27] = optionGroups;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== hasOptions || $[30] !== productData || $[31] !== productNumber || $[32] !== quantity || $[33] !== requiredOptionGroupIds || $[34] !== scrollToOptionSection || $[35] !== t16) {
    t17 = <GiftDonateButton productInfo={productData} productNumber={productNumber} selectedOptions={t16} hasOptions={hasOptions} requiredOptionGroupIds={requiredOptionGroupIds} theme="primary-fill" onOptionNotSelected={scrollToOptionSection} quantity={quantity} />;
    $[29] = hasOptions;
    $[30] = productData;
    $[31] = productNumber;
    $[32] = quantity;
    $[33] = requiredOptionGroupIds;
    $[34] = scrollToOptionSection;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[37] !== t15 || $[38] !== t17) {
    t18 = <div className={t8}>{t15}{t17}</div>;
    $[37] = t15;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18 || $[41] !== t3 || $[42] !== t4 || $[43] !== t7) {
    t19 = <form onSubmit={t3} className={t4}>{t7}{t18}</form>;
    $[40] = t18;
    $[41] = t3;
    $[42] = t4;
    $[43] = t7;
    $[44] = t19;
  } else {
    t19 = $[44];
  }
  return t19;
};
function _temp(g) {
  return g.requiredYN;
}
function _temp2(selectedOption) {
  return selectedOption.extraProductPrice;
}
function _temp3(g_1) {
  return g_1.requiredYN;
}
function _temp4(g_2) {
  return g_2.optionGroupId;
}
function _temp5(e) {
  e.preventDefault();
}